<template>
  <footer>
    <Container fluid>
      <Div class="row justify-content-center bildschirmansicht py-3">
        <Div class="col-11">
          <hr />
        </Div>
      </Div>

      <Div class="row justify-content-center py-3 ">
        <Div class="col-md-3">
          <h4 class="fw-bolder">
            <router-link to="/impressum" class="footerLink">{{
              $t("impressum")
            }}</router-link>
          </h4>
        </Div>
        <Div class="col-md-6">
          {{ $t("adresseName") }}, {{ $t("adresseStrasse") }}, {{ $t("adresseOrt")
          }}<br />
          <i class="fas fa-phone ps-4 pe-2"> </i>{{ $t("adresseTel") }},
          <i class="fas fa-fax ps-4 pe-2"> </i>{{ $t("adresseFax") }},
          <a :href="'mailto:' + $t('adresseMail') + '@' + $t('adresseDomain')"
           class="noDekoration"
            ><i class="far fa-envelope-open ps-4 pe-2 " style="font-size: 1.3em"></i>
            <span> {{ $t("adresseMail") }}@{{ $t("adresseDomain") }}</span></a
          >
        </Div>
        <Div class="col-md-3">
          <h4 class="fw-bolder">
            <router-link to="/datenschutz" class="footerLink">{{
              $t("datenschutz")
            }}</router-link>
          </h4>
        </Div>
      </Div>
      <Div class="row justify-content-center pt-md-3">
        <Div class="col-md-3">
          <p>&copy; {{new Date().getFullYear()}} {{ $t("adresseName") }}</p>
        </Div>
      </Div>
      
      <Div class="row justify-content-center">
        <Div class="col-md-3">
          <a href="https://pillarsoft.de" class="pillarsoft" >Design by Pillarsoft</a>
        </Div>
      </Div>
      <Div
        class="row justify-content-center "
        v-if="HomepageCookiePillarSoft != $t('adresseName')"
      >
        <Div class="col-md-6">
          Wir setzen auf unserer Website kein herkömmliches Cookie-basiertes Tracking ein.
          Unsere Analysemethoden schützen Ihre Privatsphäre und helfen uns, Ihr
          Nutzererlebnis kontinuierlich zu verbessern.
        </Div>
        <Div class="col-md-3">
          <button
            type="button"
            class="btn btn-outline-danger mx-3 px-2"
            @click="openCookieDetail()"
          >
            Details
          </button>
          <button type="button" class="btn btn-danger px-2" @click="setCookie()">
            Hinweis schließen
          </button>
        </Div>
      </Div>
    </Container>
  </footer>
</template>

<script>
import ModalCookieDetail from "../components/ModalCookieDetail.vue";
import { openModal } from "jenesius-vue-modal";
export default {
  name: "AppFooter",
  data() {
    return {
      HomepageCookiePillarSoft: "",
    };
  },
  methods: {
    openCookieDetail() {
      openModal(ModalCookieDetail);
    },
    setCookie() {
      // Cookie setzen
      this.$cookies.set("HomepageCookiePillarSoft", this.$t("adresseName"));
      this.HomepageCookiePillarSoft = this.$t("adresseName");
    },
  },
  mounted() {
    // Cookie auslesen
    this.HomepageCookiePillarSoft = this.$cookies.get("HomepageCookiePillarSoft");
    console.log("HomepageCookiePillarSoft:", this.HomepageCookiePillarSoft);
  },
};
</script>
